import React, { useState, useEffect } from "react";
import { StyleSheet, View, Text, Image } from '../../core';
import Touchable from "../TouchableComponent";
import { commonStyles } from "../../assets/css/commonStyle";
import { commonFontStyles } from "../../assets/css/commonFontStyles";
import { PAYMENT_MODE } from "../../constant/app.data.constant";
import { useStripe } from "@stripe/react-stripe-js";
import apple_pay_white from "../../assets/images/apple_pay_white.png";

const SafariPayment = ({ props, paymentDataRequest, handleApplePayEnabled }) => {
  let { amtPayable, subject, isLoading, showGooglePay, bill } = props;
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    if (stripe) {
      try {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        subject = (!!paymentDataRequest.transactionInfo && !!paymentDataRequest.transactionInfo.displayItems && paymentDataRequest.transactionInfo.displayItems.length > 0) ? paymentDataRequest.transactionInfo.displayItems[0].label : subject;
      } catch (error) {
      }
      const payload = {
        country:  bill.transactiondetails.countryCode,
        currency: bill.transactiondetails.currency,
        total: {
          label: subject,
          amount: Math.round(amtPayable * 100),
        },
        requestPayerName: true,
        requestPayerEmail: true,
      }
      const pr = stripe.paymentRequest(payload);

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then((result) => {
        if (result) {
          setIsApplePayAvailable(true);
          handleApplePayEnabled(true); // Notify parent that Apple Pay is available
          setPaymentRequest(pr);
        } else {
          setIsApplePayAvailable(false);
        }
      });
    }
  }, [stripe, amtPayable, subject]);

  if (paymentRequest && !!!isLoading) {
    paymentRequest.on("paymentmethod", async (ev) => {
      const { onPaymentDone } = props;
      let payload = {
        tokendetails: {
          cardtoken: ev.paymentMethod.id,
          payment_intent: 0,
        },
        transactiondetails: {
          total_amount: parseFloat(
            paymentDataRequest.transactionInfo.totalPrice
          ),
          currency: paymentDataRequest.transactionInfo.currencyCode,
          purchase_level: 1,
          transaction_date: new Date(),
          transaction_description: `bill payment ${paymentDataRequest.merchantInfo.merchantName}`,
        },
        billingaddress: {
          billing_username: ev.paymentMethod.billing_details.name,
          user_email: ev.paymentMethod.billing_details.email,
          phone_Number: ev.paymentMethod.billing_details.phone,
          user_address1: ev.paymentMethod.billing_details.address.line1,
          user_address2: ev.paymentMethod.billing_details.address.line2,
          user_zip: ev.paymentMethod.billing_details.address.postal_code,
          user_city: ev.paymentMethod.billing_details.address.city,
          user_state: ev.paymentMethod.billing_details.address.state,
        },
      };
      let response = {};
      response = await props.app.dm.billDetails.stripePaymentCheckout(payload);
      response.paymentMode = PAYMENT_MODE.APPLE_PAY;
      response.totalAmount = parseFloat(
        paymentDataRequest.transactionInfo.totalPrice
      );
      response.achBankAccountId = "Apple Wallet";
      const { paymentIntent, error: confirmError } =
        await stripe.confirmCardPayment(
          response.transactionId,
          { payment_method: ev.paymentMethod.id },
          { handleActions: false }
        );

      if (confirmError) {
        ev.complete("fail");
        let response = {
          success: false,
          error: confirmError,
        };
        onPaymentDone(response);
      } else {
        ev.complete("success");
        onPaymentDone(response);
        if (paymentIntent.status === "requires_action") {
          const { error } = await stripe.confirmCardPayment(
            response.transactionId
          );
          if (error) {
            ev.complete("fail");
            let response = {
              success: false,
              error: error,
            };
            onPaymentDone(response);
          } else {
            ev.complete("success");
            onPaymentDone(response);
          }
        } else {
          ev.complete("success");
          onPaymentDone(response);
          // The payment has succeeded.
        }
      }
    });
    return (
      <Touchable onPress={async () => paymentRequest.show()} style={[commonStyles.fullFlexContainer]}>
        <View style={[!!showGooglePay ? styles.showApplyIcon : styles.paymentButtonWrapper]}>
          {!!isApplePayAvailable ? <Image source={apple_pay_white} style={[styles.applyPayIconImage]} /> :
            <Text style={[commonFontStyles.workSans, commonStyles.exSmallHeading, commonStyles.fontWeight500, commonStyles.whiteColor, commonStyles.disabledBtnText]}>{"APPLE PAY"}</Text>}
        </View>
      </Touchable>
    );
  }

  return (
    <Touchable onPress={async () => console.log('disabled')} disabled={!paymentRequest} style={[commonStyles.fullFlexContainer]}>
      <View style={[!!isApplePayAvailable ? styles.showApplyIcon : styles.paymentButtonWrapper, !isApplePayAvailable && commonStyles.disable, !isApplePayAvailable && commonStyles.disabledBtn]}>
        {!!isApplePayAvailable ? <Image source={apple_pay_white} style={[styles.applyPayIconImage]} /> :
          <Text style={[commonFontStyles.workSans, commonStyles.exSmallHeading, commonStyles.fontWeight500, commonStyles.whiteColor, commonStyles.disabledBtnText]}>{"APPLE PAY"}</Text>}
      </View>
    </Touchable>
  );
};

export default SafariPayment;

const styles = StyleSheet.create({
  paymentButtonWrapper: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#f4f4f4',
    backgroundColor: "#f4f4f4",
    borderRadius: 5,
    padding: 5,
    width: "100%",
    height: 24,
    flex: 1,
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          width: "auto",
          minWidth: "100%",
          marginRight: 0,
          flexBasis: "100%",
          marginLeft: 0,
        }
      }
    }
  },
  showApplyIcon: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 5,
    backgroundColor: "#000",
    width: "100%",
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: "100%"
  },
  applyPayIconImage: {
    width: 38,
    height: 28,
    borderColor: '#000',
    borderWidth: 1,
    borderRadius: 50,
    borderStyle: 'solid',
    display: "block",
    backgroundSize: "contain",
  },
});
